export enum FIXED_TABLE_VALUES {
    UNIDADE = 'Unidade',
    STATUS = 'Status',
    VALOR = 'Valor',
}

export enum STATUS {
    RESERVED = 'RESERVED',
    AVAILABLE = 'AVAILABLE',
    UNAVAILABLE = 'UNAVAILABLE',
}

export interface ISearchTableSalesFilters {
    realEstateName: string
}

export interface ICell {
    id?: number
    value: string
    columnId: number
}

export interface IFieldArray {
    id?: string
    columnId?: number
    name?: string
    value?: string
    cells?: ICell[]
    rowNumber?: number
}

export interface IListTableSales {
    id: number
    tableDate: string
    name: string
    hasTemplate: boolean
    realEstate: {
        name: string
    }
}

export interface ITableSales {
    id: number
    tableDate: string
    name: string
    realEstateId?: number
    realEstate?: {
        id: number
        name: string
    }
    hasTemplate?: boolean
    file?: File | null
    columns: IFieldArray[]
    rows: IFieldArray[]
}

export interface ITemplate {
    template: string
}

export interface IPdfLink {
    fileFromS3: string
}

export interface ICreateTableSales {
    realEstateId: string
    tableDate: string
    name: string
    file?: File | null
    removeTemplate?: boolean
    columns: IFieldArray[]
    rows: IFieldArray[]
}
